import React from 'react';
import TECHNOLOGIES from '../data/technologies';

const Technology = props => {
    const { id, section, title, description, cssId } = props.technologies;
    return (
        <div className="techTotal">
            <h3 id={cssId} ></h3>
            <h2 className="techTotal">{title}</h2>
            <ul className="descriptionList">
                {description.map(desc => <li>{desc}</li>)}
            </ul>
        </div>
    )

}

const Technologies = () => (
    <div className="techSection">
        <h1 id="techHeader">Technical Expertise</h1>
        <div className="techSectionInner">

            {
                TECHNOLOGIES.map(TECHNOLOGY => {
                    return (
                        <Technology key={TECHNOLOGY.id} technologies={TECHNOLOGY} />
                    );
                })
            }
        </div>
        
    </div>
)

export default Technologies;